/*
 * The editor's colour and highlight palette.
 *
 * These are CLASSES, not inline hex values, on purpose. An author who picks
 * `color: #111827` from a colour picker produces text that is invisible on the
 * dark theme — and the article body has to work in both. Each class below is
 * defined twice in App.css (light + dark) so a highlight stays readable either
 * way, and the palette stays consistent with the rest of the design system.
 *
 * `swatch` is only what the toolbar button shows; it is never written into the
 * saved HTML.
 *
 * ALLOWED_CLASSES is the allowlist src/utils/sanitizeHtml.js checks the `class`
 * attribute against, so adding an entry here is all that is needed to make a new
 * style survive sanitisation. Add the matching CSS in App.css.
 */

export const TEXT_COLORS = [
  { className: 'tc-brand', label: 'Brand', swatch: '#0f766e' },
  { className: 'tc-blue', label: 'Blue', swatch: '#1d4ed8' },
  { className: 'tc-purple', label: 'Purple', swatch: '#6d28d9' },
  { className: 'tc-amber', label: 'Amber', swatch: '#b45309' },
  { className: 'tc-rose', label: 'Rose', swatch: '#be123c' },
  { className: 'tc-green', label: 'Green', swatch: '#15803d' },
  { className: 'tc-muted', label: 'Muted', swatch: '#6b7280' },
];

export const HIGHLIGHTS = [
  { className: 'hl-yellow', label: 'Yellow', swatch: '#fde68a' },
  { className: 'hl-teal', label: 'Teal', swatch: '#99f6e4' },
  { className: 'hl-blue', label: 'Blue', swatch: '#bfdbfe' },
  { className: 'hl-pink', label: 'Pink', swatch: '#fbcfe8' },
  { className: 'hl-green', label: 'Green', swatch: '#bbf7d0' },
];

export const ALLOWED_CLASSES = new Set([
  ...TEXT_COLORS.map((c) => c.className),
  ...HIGHLIGHTS.map((h) => h.className),
  // Callout variants, applied to a blockquote.
  'callout',
  'callout-info',
  'callout-warn',
  'callout-tip',
  // Set by the code-block button; the article stylesheet keys off `pre code`
  // but a language hint is useful if syntax highlighting is added later.
  'language-none',
]);
